import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { FAQs, SIDE_NAV } from 'src/app/Shared/VAIDS.Constants';

@Component({
  selector: 'app-vaids-splash-page',
  templateUrl: './vaids-splash-page.component.html',
  styleUrls: ['./vaids-splash-page.component.css']
})
export class VaidsSplashPageComponent implements OnInit, AfterViewInit {
  faqs = FAQs;
  sideNavItems = SIDE_NAV;
  activeSection: string = this.sideNavItems[0].id;

  searchForm!: FormGroup

  private isScrolling = false;
  private scrollTimeout: any;

  constructor(private readonly fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngAfterViewInit() {
    const observer = new IntersectionObserver(
      entries => {
        if (this.isScrolling) return; // Ignore observer while smooth scrolling

        // Sort by visibility ratio, pick the most visible one
        const visible = entries
          .filter(e => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

        if (visible.length > 0) {
          this.activeSection = visible[0].target.id;
        }
      },
      {
        // threshold: [0, 0.25, 0.5, 0.75, 1], // Multiple thresholds for small sections
        threshold: [0.5], // Multiple thresholds for small sections
        rootMargin: '-10% 0px -50% 0px'     // Bias toward top of viewport
      }
    );

    this.sideNavItems.forEach(item => {
      const element = document.getElementById(item.id);
      if (element) {
        observer.observe(element);
      }
    });
  }

  scrollIntoView(id: string) {
    this.activeSection = id;
    this.isScrolling = true;

    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      this.isScrolling = false;
    }, 1000); // Adjust based on your smooth scroll duration

    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  private initForm() {
    this.searchForm = this.fb.group({
      search: this.fb.control({value: '', disabled: false})
    })

    this.searchForm.valueChanges.pipe(debounceTime(1000)).subscribe({
      next: (value: {search: string}) => {
        const regex = new RegExp(this.escapeRegex(value.search), 'i');
        
        this.faqs = FAQs.filter((item): boolean => {
          if (regex.test(item.header)) return true;
          if (regex.test(item.subHeader)) return true;

          const questionsAndAnswers = item.questionsAndAnswers;
          if (questionsAndAnswers && questionsAndAnswers.length > 0) {

            for (let i = 0; i < questionsAndAnswers.length; i++) {
              const qa = questionsAndAnswers[i];
              if (regex.test(qa.question)) return true;
              if (regex.test(qa.answer)) return true;

              const children = qa.children;

              if (children && children.length > 0) {
                for (let j = 0; j < children.length; j++) {
                  const child = children[j];
                  if (regex.test(child)) true;
                }
              }
            }
          }
          return false;
        })
      }
    })
  }

  private escapeRegex(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  }
}
